import { render, staticRenderFns } from "./promptTableTwo.vue?vue&type=template&id=50b0f7c0&scoped=true&"
import script from "./promptTableTwo.vue?vue&type=script&lang=js&"
export * from "./promptTableTwo.vue?vue&type=script&lang=js&"
import style0 from "./promptTableTwo.vue?vue&type=style&index=0&id=50b0f7c0&lang=scss&scoped=true&"
import style1 from "./promptTableTwo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b0f7c0",
  null
  
)

export default component.exports